import { Resource } from "../resource/resource.model";

export class PreferenceForm extends Resource {
    activeVersion: number;
    internalName: string;
    preferencesIds: string[];
    tenantId: string;
}
